import { Injectable } from '@angular/core';
import { NestedDirective } from '../component/nested.directive';

@Injectable({
    providedIn: 'root'
})
export class NestedHelpersService {

    constructor() { }

    filter(value?: NestedDirective[], tag?: string): NestedDirective[] {
        const visibleList = value?.filter(nested => nested.isVisible) ?? [];

        return !tag ? visibleList : visibleList?.filter(nested => nested.tag === tag);
    }
}
